import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/auth/signin";
import DashboardPage from "./pages/dashboard";
import { SignupPage } from "./pages/auth/signup/SignupContainer";
import AccountPage from "./pages/account";
import RecordersPage from "./pages/recorders";
import RecorderRecordersPage from "./pages/recorders/recorders/index";
import RecorderListPage from "./pages/recorders/recorders/list/index";
import RecorderListEditPage from "./pages/recorders/edit/list";
import RecorderGroupPage from "./pages/recorders/groups";
import UserPage from "pages/users";
import UserListPage from "./pages/users/userList";
import UserGroupPage from "./pages/users/userGroup";
import AlertRulePage from "./pages/alert/rule";
import AlertPage from "./pages/alert";
import AlertHistoryPage from "./pages/alert/history";
import AlertHistoryDetail from "./pages/alert/history/detail/AlertHistoryDetail";
import ReportPage from "./pages/reports";
import ReportType from "./pages/reports/view";
import VideoSharePage from "./pages/videoshare/list";
import VideoShareView from "./pages/videoshare/view";
import SettingPage from "./pages/setting";
import EmailPage from "./pages/manager/email";
import NoticePage from "./pages/manager/siteNotices";
import AdminAccountPage from "./pages/setting/myAccount";
import MyProfilePage from "./pages/setting/myProfile";
import Verfiy2faPage from "./pages/auth/verify2fa";

import HelpPage from "./pages/help";
import SubscriptionPage from "./pages/subscription";
import SubscriptionOrgList from "./pages/subscription/organization/list";
import SubscriptionKeyList from "./pages/subscription/keys";
import SubscriptionServicePricing from "./pages/subscription/servicePricing";
import SubscriptionLyvePage from "./pages/subscription/lyve";
import ProtectedRoute from "components/routes/ProtectedRoute";
import { MainLayout } from "components/templates/layout/MainLayout";

import VideoManager from "./pages/manager/videoManager";
import TechManager from "./pages/manager/troubleManager";
import OperationManager from "./pages/manager/operationManager";
import GuestShare from "pages/guest/videoShare/GuestShare";
import Notfound from "components/templates/nopage/Notfound";
import OrgNotfound from "components/templates/nopage/OrgNotfound";
import HealthDetail from "pages/reports/view/health/HealthDetail";
import AlertViewPage from "pages/alert/view";
import AlertActive from "pages/alert/active";
import AlertHistoryDetailPage from "pages/alert/history/detail";
import AlertHistoryListComponent from "pages/alert/history/AlertHistoryList";
import InformationPage from "pages/setting/information";
import FeaturesPage from "pages/manager/features";
import SubscriptionRequestHistory from "pages/subscription/keys/request-history";
import TermsPage from "pages/terms";
import AccountAccessConfirm from "pages/account/access/confirm";
import CameraContainer from "pages/recorders/recorders/cameras/index";
import Maintainance from "pages/maintenance";
import Firmware from "pages/maintenance/firmware";
import Configuration from "pages/maintenance/Configuration";
import PlanOrganization from "pages/subscription/usage/organization";
import EventToHistory from "pages/subscription/usage/eventToHistory";
import BillToDate from "pages/subscription/usage/billToDate";
import UsageLayout from "pages/subscription/usage/UsageLayout";
import UsageEntry from "pages/subscription/usage/UsageEntry";
import UsageSignup from "pages/subscription/usage/signup";
import SubscriptionHistory from "pages/subscription/history";
import PaymentSuccess from "pages/subscription/usage/signup/payment/success";
import KeysEntry from "pages/subscription/keys/KeysEntry";
import { useFlag } from "@unleash/proxy-client-react";
import ReleaseNotesPage from "pages/manager/releaseNotes";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import AdminUnlock from "pages/maintenance/adminUnlock";
import { checkIsSubCP } from "utils/AccountUtil";
import StagingRecorder from "pages/maintenance/staging";
import StagingRecorderList from "pages/maintenance/staging/recorders";
import StagingEdit from "pages/maintenance/staging/recorders/edit";
import StagingHistory from "pages/maintenance/staging/history";
import StagingAssign from "pages/maintenance/staging/assign";

export default function RoutesContainer() {
  const isFirmwareUpgradeEnable = useFlag("feature_manage_firmwareUpgrade");
  const isCovaConfigEnable = useFlag("feature_report_inventory_cova_config");
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const isStagingRecorderEnable = useFlag("feature_maintenance_staging");
  const isPlanHide = useFlag("feature_plan_hide");
  return (
    <Routes>
      <Route>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/login/free-trial" element={<SignupPage />} />
        <Route path="/login/setup-passkey" element={<LoginPage />} />
        <Route path="/callback" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/reseller" element={<SignupPage />} />
        <Route path="/reset" element={<SignupPage />} />

        <Route path="/tmp-access/confirm" element={<AccountAccessConfirm />} />
        <Route path="/guest/video/player" element={<GuestShare />} />
        <Route path="/verify/2fa" element={<Verfiy2faPage />} />
        {!isPlanHide && (
          <>
            <Route
              path="/subscription/usage/payment/success"
              element={<PaymentSuccess />}
            />
            <Route
              path="/subscription/usage/payment/cancel"
              element={<UsageEntry />}
            />
          </>
        )}
        <Route path="/terms/*">
          <Route path="*" element={<TermsPage />} />
        </Route>
      </Route>

      <Route element={<MainLayout />}>
        <Route path="/reports" element={<ReportPage />} />
        <Route path="/reports/:type/:reportId/*" element={<ReportType />} />
        <Route
          path="/reports/:type/merged/:reportId/:mergedSystemId"
          element={<ReportType />}
        />
        <Route
          path="/reports/:type/detail/:reportId/:recorderId"
          element={<HealthDetail />}
        />

        <Route path="/alert/active" element={<AlertPage />}>
          <Route index element={<AlertActive />} />
          <Route path="view" element={<AlertViewPage />} />
        </Route>
        <Route path="/alert/rules/*" element={<AlertRulePage />} />

        <Route path="/alert/history" element={<AlertHistoryPage />}>
          <Route index element={<AlertHistoryListComponent />} />
        </Route>

        <Route
          path="/alert/history/detail"
          element={<AlertHistoryDetailPage />}
        >
          <Route index element={<AlertHistoryDetail />} />
          <Route path="view" element={<AlertViewPage />} />
        </Route>

        <Route path="/recorders" element={<RecordersPage />}>
          <Route path="list" element={<RecorderRecordersPage />}>
            <Route index element={<RecorderListPage />} />
            <Route path="edit" element={<RecorderListEditPage />} />
            <Route path="cameras/:mergedSystemId" element={<CameraContainer />}>
              <Route path=":recorderId" element={<CameraContainer />} />
            </Route>
          </Route>
          <Route path="groups" element={<RecorderGroupPage />} />
        </Route>
        {/* <Route path="/recorders/groups" element={<RecordersPage />} />
        <Route path="/recorders/groups/*" element={<RecordersPage />} />
        <Route path="/recorders/list" element={<RecordersPage />} />
        <Route
          path="/recorders/list/cameras/:mergedSystemId"
          element={<CameraContainer />}
        />
        <Route
          path="/recorders/list/cameras/:mergedSystemId/:recorderId"
          element={<CameraContainer />}
        /> */}

        <Route path="/videoShare" element={<VideoSharePage />} />
        <Route path="/videoShare/:videoId" element={<VideoShareView />} />
        <Route path="/dashboard/*" element={<DashboardPage />} />

        <Route path="/users" element={<UserPage />}>
          <Route path="list" element={<UserListPage />} />
          <Route path="groups" element={<UserGroupPage />} />
        </Route>

        <Route path="/account" element={<AccountPage />} />

        <Route path="/subscription">
          <Route element={<SubscriptionPage />}>
            <Route path="organization">
              <Route index element={<SubscriptionOrgList />} />
              <Route path="history" element={<SubscriptionHistory />} />
            </Route>
            <Route path="services" element={<SubscriptionServicePricing />} />
            <Route path="lyve/*" element={<SubscriptionLyvePage />} />
            <Route path="lyve/:bucketName" element={<SubscriptionLyvePage />} />
            {selectedAccount.accountLevel !== LEVEL_TYPE.CP && (
              <Route path="keys" element={<SubscriptionKeyList />} />
            )}
          </Route>

          {selectedAccount.accountLevel === LEVEL_TYPE.CP && (
            <>
              <Route path="keys">
                <Route index element={<KeysEntry />} />
                <Route element={<SubscriptionPage />}>
                  <Route
                    index
                    path="organization"
                    element={<SubscriptionOrgList />}
                  />
                  <Route
                    path="organization/history"
                    element={<SubscriptionHistory />}
                  />
                  <Route path="list" element={<SubscriptionKeyList />} />
                  <Route
                    path="request-history"
                    element={<SubscriptionRequestHistory />}
                  />
                </Route>
              </Route>
            </>
          )}
          {!isPlanHide && !checkIsSubCP(selectedAccount) && (
            <Route path="usage">
              <Route index element={<UsageEntry />} />
              <Route path="signup" element={<UsageSignup />}></Route>
              <Route element={<UsageLayout />}>
                <Route path="organization" element={<PlanOrganization />} />
                <Route path="history" element={<EventToHistory />} />
                <Route path="billing" element={<BillToDate />} />
              </Route>
            </Route>
          )}
        </Route>

        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <SettingPage />
            </ProtectedRoute>
          }
        >
          <Route path="emails" element={<EmailPage />}></Route>
          <Route path="notices" element={<NoticePage />}></Route>
          <Route path="myaccount" element={<MyProfilePage />}></Route>
          <Route path="adminAccount" element={<AdminAccountPage />}></Route>
          <Route path="information" element={<InformationPage />}></Route>
        </Route>
        <Route path="/maintenance">
          <Route index element={<Maintainance />} />
          {isFirmwareUpgradeEnable && (
            <Route path="firmware" element={<Firmware />} />
          )}
          {isCovaConfigEnable && (
            <Route path="configuration" element={<Configuration />} />
          )}
          <Route path="adminUnlock" element={<AdminUnlock />} />
          {isStagingRecorderEnable && (
            <Route path="staging" element={<StagingRecorder />}>
              <Route index element={<StagingRecorderList />} />
              <Route path="edit" element={<StagingEdit />} />
              <Route path="history" element={<StagingHistory />} />
              <Route
                path="cameras/:mergedSystemId"
                element={<CameraContainer />}
              >
                <Route path=":recorderId" element={<CameraContainer />} />
              </Route>
              <Route path="assign" element={<StagingAssign />} />
            </Route>
          )}
        </Route>
        <Route path="/manager">
          <Route path="guideSetting" element={<VideoManager />} />
          <Route path="features" element={<FeaturesPage />} />
          <Route path="techSummit" element={<TechManager />} />
          <Route path="operationLog" element={<OperationManager />} />
          <Route path="emails" element={<EmailPage />} />
          <Route
            path="emails/recipients/:subject/:id"
            element={<EmailPage />}
          />
          <Route path="sitenotices" element={<NoticePage />} />
          <Route path="releaseNotes" element={<ReleaseNotesPage />} />
        </Route>

        <Route path="/help/*" element={<HelpPage />} />

        <Route
          path="/protected"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        {/* <Route path="*" element={<Notfound />} /> */}
      </Route>
      <Route path="/error/403" element={<OrgNotfound />} />
      <Route path="*" element={<Notfound />} />
    </Routes>
  );
}
